<template>
  <div :class="{ 'app--is-loading': isLoading }" class="app">
    <!-- Loading overlay -->
    <div v-if="isLoading" class="app__loading-wrapper">
      <dd-loading />
    </div> 
    <!-- Main view -->
    <router-view v-if="!error && !MAINTENANCE_MODE" :key="$route.path" />
    <!-- Maintenance view  -->
    <maintenance-screen v-if="MAINTENANCE_MODE" />
    <!-- Error view -->
    <error-screen v-if="!isLoading && error && !MAINTENANCE_MODE" /> 
  </div>
</template>
<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import config from '@/config'

/* Mixins */

/* Components */
import ErrorScreen from '@/screens/errors/error-screen.vue'
import MaintenanceScreen from '@/screens/maintenance/maintenance.vue'

/* Helpers */
import { mapState } from 'pinia'
import LocalStore from '@/helpers/localstore'
import { useAppStore } from '@/modules/app/app.store'

/* Data types */

/* API */
import UserAPI from '@/api/modules/user.api'

export default defineComponent({
  components: {
    ErrorScreen,
    MaintenanceScreen,
  },
  data() {
    return {
      MAINTENANCE_MODE: false,
      oneSignalPoller: null as any,
      oneSignalPollMax: 10,
      oneSignalPollCount: 0,
      oneSignalPollIntervalInMS: 1000,
    }
  },
  head: {
    title: 'DoneDone',
    titleTemplate: titleChunk => {
      // If undefined or blank then we don't need the hyphen
      return titleChunk ? `${titleChunk}` : 'DoneDone'
    },
  },
  computed: {
    ...mapState(useAppStore, ['isLoading', 'error']),
  },
  watch: {
    error(newVal) {
      if (newVal) {
        useAppStore().isLoading = false
      }
    },
    oneSignalPollCount: {
      handler(newValue) {
        if (newValue >= this.oneSignalPollMax) {
          this.endPollForOneSignalInfo()
        }
      },
    },
  },
  async created() {
    if (config.maintenanceMode) {
      this.MAINTENANCE_MODE = true
    }
    if (this.$screen.isGoNativeApp()) {
      this.startPollForOneSignalInfo()
    }
  },
  methods: {
    startPollForOneSignalInfo() {
      // Ensure we're clearing old polling, if necessary
      this.endPollForOneSignalInfo()
      this.oneSignalPoller = setInterval(async () => {
        this.oneSignalPollCount++
        await this.fetchAndSubmitOneSignalInfo()
      }, this.oneSignalPollIntervalInMS)
    },
    endPollForOneSignalInfo() {
      clearInterval(this.oneSignalPoller)
    },
    async fetchAndSubmitOneSignalInfo() {
      // Push onesignal user device asssocation set from index.html, if necessary...
      if (LocalStore.oneSignalUserDeviceAssociationInfo) {
        this.endPollForOneSignalInfo()
        await UserAPI.post_OneSignalUserDeviceAssociation(
          LocalStore.oneSignalUserDeviceAssociationInfo,
        )
        LocalStore.clearOneSignalUserDeviceAssociationInfo()
      }
    },
  },
})
</script>


<style lang="scss">
.app {
  position: relative;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  @include media-breakpoint-up(sm) {
    height: 100%;
  }
  &--is-loading {
    overflow-y: hidden;
  }
  &__loading-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100000;
    background-color: var(--color-background-primary);
    .dd-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
